document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('fs-sticky-atc');
  if (!stickyBar) return;

  const stickyBtn = document.querySelector('[data-sticky-atc-trigger]');
  const originalAtc = document.querySelector(
    'product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]'
  );
  if (!originalAtc) return;

  // Footer-Element finden
  const footer = document.querySelector('footer, [role="contentinfo"], .footer');

  let ticking = false;

  function isAtcDisabled() {
    return originalAtc.disabled || originalAtc.hasAttribute('disabled');
  }

  function updateStickyVisibility() {
    const rect = originalAtc.getBoundingClientRect();
    const isDisabled = isAtcDisabled();
    
    // Prüfen ob Footer sichtbar ist
    let footerVisible = false;
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      footerVisible = footerRect.top < window.innerHeight;
    }
    
    // Sticky nur zeigen wenn:
    // 1. Button ist ÜBER dem Viewport (user hat vorbei gescrollt)
    // 2. Button ist nicht disabled
    // 3. Footer ist NICHT sichtbar
    const hasScrolledPast = rect.bottom < -100;
    
    if (hasScrolledPast && !isDisabled && !footerVisible) {
      stickyBar.removeAttribute('data-hidden');
    } else {
      stickyBar.setAttribute('data-hidden', '');
    }

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(updateStickyVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', updateStickyVisibility);
  updateStickyVisibility();

  document.addEventListener('variant:change', updateStickyVisibility);
  document.addEventListener('shopify:section:load', updateStickyVisibility);

  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      if (isAtcDisabled()) return;
      originalAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        if (!isAtcDisabled()) originalAtc.click();
      }, 400);
    });
  }
});